import {Button, Card, Col, Divider, Row, Select, Typography} from "antd";
import ProjectInfo from "../Components/ProjectInfo";
import SelectPlan from "../Components/SelectPlan";
import {useEffect, useState} from "react";
import {useProject} from "../Context/ProjectContext";
import CheckResult2 from "../Components/CheckResult2";
import ApiService from "../Service/ApiService";
import OperationManager, {OPS_STATUS} from "../Components/OperationManager";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import HecRasHelper from "../Helpers/HecRasHelper";
import CompareSummaryPanel from "../Components/CompareSummaryPanel";
import {useUser} from "../Context/UserContext";
import CrossSectionFilter from "../Components/CrossSectionFilter";
import EmptyLine from "../Components/EmptyLine";

const enable = true
const time = 0
const noIssueText = 'There is no difference in this comparison point.'


const showIndicator = ({data}) => {
    try {
        return data?.result?.length > 0 && data?.result?.find(x => x?.data?.length > 0 || !(x?.data))
    }
    catch (exp) {
        return false
    }
}

const request = async ({key, baseHash, compareHash, target}) => {
    const res = await ApiService.RasCheck.CompareCheck({target, key, baseHash, compareHash});
    if(res.success)
        return JSON.parse(res.data)

    throw new Error('Error')
}

const getOperations = () => {
    return [
        {
            title: 'Cross Section',
            children: [
                {title: 'Add/Remove Cross Section', key: 'C1', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_add_rem_cross_section'}),  Component: CheckResult2, target: 'compare_add_rem_cross_section', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Cross Section Station/Elevation', key: 'C2', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_cross_section_sta_elev'}),  Component: CheckResult2, target: 'compare_cross_section_sta_elev', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'DS Reach Length', key: 'C20', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_ds_reach_length'}),  Component: CheckResult2, target: 'compare_ds_reach_length', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Structure',
            children: [
                {title: 'Add/Remove Structure', key: 'C3', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_add_rem_structure'}),  Component: CheckResult2, target: 'compare_add_rem_structure', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Structure Geometry', key: 'C4', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_structure_geo'}),  Component: CheckResult2, target: 'compare_structure_geo', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Bridge Modeling Approach', key: 'C5', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_bridge_modelling_method'}),  Component: CheckResult2, target: 'compare_bridge_modelling_method', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: "Manning’s n",
            children: [
                {title: "Manning's n", key: 'C6', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_mannings'}),  Component: CheckResult2, target: 'compare_mannings', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Transition Coefficient',
            children: [
                {title: 'Contraction/Expansion Coefficient', key: 'C12', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_exp_cont'}),  Component: CheckResult2, target: 'compare_exp_cont', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Schematic',
            children: [
                {title: 'XS Cutlines Geo-Reference', key: 'C8', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_xs_cutlines_geo_ref'}),  Component: CheckResult2, target: 'compare_xs_cutlines_geo_ref', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Reach Invert Line Geo-Reference', key: 'C9', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_reach_invert_line'}),  Component: CheckResult2, target: 'compare_reach_invert_line', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Ineffective/Obstructed Area',
            children: [
                {title: 'Ineffective Area', key: 'C13', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_ieff_area'}),  Component: CheckResult2, target: 'compare_ieff_area', result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Obstructed Areas', key: 'C21', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_obstructed_area'}),  Component: CheckResult2, target: 'compare_obstructed_area', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Flow',
            children: [
                {title: 'Flow Data', key: 'C10', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_flow_data'}),  Component: CheckResult2, target: 'compare_flow_data', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Floodway',
            children: [
                {title: 'Encroachment Station', key: 'C7', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_enc_station'}),  Component: CheckResult2, target: 'compare_enc_station', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Output',
            children: [
                {title: '100yr WSEL', key: 'C11', request: ({key, baseHash, compareHash}) => request({key, baseHash, compareHash, target: 'compare_output_wsel'}),  Component: CheckResult2, target: 'compare_output_wsel', result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
    ]
}

export default function ComparisonCheck2() {
    const {user} = useUser()
    const {baseProject, compareProject, projectHistory, setProjectHistory, comparisonBaseId, comparisonCmpId, setComparisonBaseId, setComparisonCmpId, filter, setSummary} = useProject()
    const [running, setRunning] = useState(false)
    const [operations, setOperations] = useState(getOperations)
    const [selectedBase, setSelectedBase] = useState({})
    const [selectedCompare, setSelectedCompare] = useState({})
    const [selectedChild, setSelectedChild] = useState({})
    const [preparing, setPreparing] = useState(false)

    const parseProject = async () => {
        const id = getId();
        if(id) {
            const data = {
                selected: {
                    geometry: {
                        text: selectedBase.plan.geometry.text
                    },
                    plan: {
                        text: selectedBase.plan.plan.text,
                        type: selectedBase.plan.type
                    },
                    flow: {
                        text: selectedBase.plan.flow.text
                    },
                    project: {
                        ...selectedBase.project.information,
                        text: selectedBase.project.information.text,
                    },
                    output: selectedBase.plan.mappedProfiles ?? [],
                    profileNames: selectedBase.plan.mapProfiles,
                },
                target: {
                    geometry: {
                        text: selectedCompare.plan.geometry.text
                    },
                    plan: {
                        text: selectedCompare.plan.plan.text,
                        type: selectedCompare.plan.type
                    },
                    flow: {
                        text: selectedCompare.plan.flow.text
                    },
                    project: {
                        ...selectedCompare.project.information,
                        text: selectedCompare.project.information.text
                    },
                    output: selectedCompare.plan.mappedProfiles ?? [],
                    profileNames: selectedCompare.plan.mapProfiles,
                },
                settings: user.settings
            }

            const res = await ApiService.RasCheck.ParseCompare(data)
            if(res.success) {
                const data = JSON.parse(res.data)
                return {
                    ...data
                }
            }
        }
    }

    const getId = () => {
        if(
            selectedBase && selectedBase.plan &&
            selectedCompare && selectedCompare.plan
        ) {
            return `${selectedBase.plan.id}-${selectedCompare.plan.id}`
        }
    }

    useEffect(() => {
        const id = getId();
        if(id) {
            const history = projectHistory.find(x => x.id === id)
            setComparisonBaseId(selectedBase.plan.id)
            setComparisonCmpId(selectedCompare.plan.id)

            if(history) {
                setOperations([
                    ...history.operations
                ])
            }
            else {
                setOperations(getOperations())
            }
        }
    }, [selectedBase, selectedCompare])

    const runOperations = async ({key, baseHash, compareHash}) => {
        setOperations(operations.map(x => ({
            ...x,
            children: x.children.map(y => {
                if(!y.enable)
                    return y;

                return {
                    ...y,
                    status: OPS_STATUS.CHECKING
                }
            })
        })))

        const ops = [...operations]
        for(let i=0; i<ops.length; i++) {
            const children = ops[i].children;

            for(let x=0; x<children.length; x++) {
                let child = children[x];
                try {
                    if(!child.enable)
                        continue

                    let time = new Date();
                    const res = await child.request({key, baseHash, compareHash});
                    let time2 = new Date();

                    const sec =(time2.getTime() - time.getTime())/1000

                    if(res) {
                        child.status = OPS_STATUS.COMPLETED;
                        child.time = sec;
                        child.result = res;
                        child.enable = false;

                        setOperations(prevState => {
                            prevState[i].children[x] = child;
                            return [...prevState]
                        })
                    }
                }
                catch (exp) {
                    child.status = OPS_STATUS.ERROR;
                    child.result = {};

                    setOperations(prevState => {
                        prevState[i].children[x] = child;
                        return [...prevState]
                    })
                }
            }
        }

        return ops
    }

    return (
        <>
            <BaseLayout>
                <Card>
                    <div style={{display: 'flex', alignItems: 'end'}}>
                        <div style={{height: '100%', display: 'flex', justifyContent: 'end', flexDirection: 'column', minWidth: 354, alignItems: 'end'}}>
                            <Typography.Text style={{marginRight: 8}}>
                                <b>Select Plans</b>
                            </Typography.Text>
                        </div>
                        <div style={{flex: 1}}>
                            <Row gutter={[8,8]}>
                                <Col xs={12}>
                                    <Typography.Text>
                                        <b>Base Plan</b>
                                    </Typography.Text>
                                    <Divider type={'horizontal'} style={{margin: 0, padding: 0}} />
                                    <br/>
                                    {
                                        baseProject && baseProject.information && selectedBase && selectedBase.plan && (
                                            (
                                                <>
                                                    <ProjectInfo
                                                        autoHeight={true}
                                                        autoHeightKey={'comparer'}
                                                        folderName={selectedBase.project?.information?.folderName}
                                                        title={selectedBase.project?.information?.title}
                                                        descriptions={selectedBase.project?.information?.descriptions || []}
                                                        planTitle={selectedBase?.plan?.plan?.title}
                                                        version={selectedBase?.plan?.plan?.version}
                                                    />
                                                    <br/>
                                                </>
                                            )
                                        )
                                    }
                                </Col>
                                <Col xs={12}>
                                    <Typography.Text>
                                        <b>Comparison Plan</b>
                                    </Typography.Text>
                                    <Divider type={'horizontal'} style={{margin: 0, padding: 0}} />
                                    <br/>
                                    {
                                        compareProject && compareProject.information && (
                                            <>
                                                <ProjectInfo
                                                    autoHeight={true}
                                                    autoHeightKey={'comparer'}
                                                    folderName={selectedCompare.project?.information?.folderName}
                                                    title={selectedCompare.project?.information?.title}
                                                    descriptions={selectedCompare.project?.information?.descriptions || []}
                                                    planTitle={selectedCompare?.plan?.plan?.title}
                                                    version={selectedCompare?.plan?.plan?.version}
                                                />
                                                <br/>
                                            </>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row gutter={[8,8]}>
                                <Col xs={12}>
                                    <SelectPlan
                                        value={comparisonBaseId}
                                        disabled={running}
                                        style={{width: '100%'}}
                                        modelA={baseProject}
                                        modelB={compareProject}
                                        onPlanChanged={({project, plan, model, id, projectHash}) => {
                                            setSelectedBase({
                                                ...selectedBase,
                                                plan,
                                                project,
                                                model,
                                                projectHash
                                            })
                                            setComparisonBaseId(id)
                                        }}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <div style={{display: 'flex', gap: 8}}>
                                        <SelectPlan
                                            value={comparisonCmpId}
                                            disabled={running}
                                            style={{width: '100%'}}
                                            modelA={baseProject}
                                            modelB={compareProject}
                                            onPlanChanged={({project, plan, model, id, projectHash}) => {
                                                setSelectedCompare({
                                                    ...selectedCompare,
                                                    plan,
                                                    project,
                                                    model,
                                                    projectHash
                                                })
                                                setComparisonCmpId(id)
                                            }}
                                        />
                                        <Button
                                            disabled={running}
                                            size={'small'}
                                            type={'primary'}
                                            onClick={
                                                async () => {
                                                    const id = getId();

                                                    setSelectedChild({x: -1, y: -1})
                                                    setPreparing(true)
                                                    setRunning(true)

                                                    const parsed = await parseProject()
                                                    setSummary({
                                                        id,
                                                        summary: parsed
                                                    })
                                                    setPreparing(false)

                                                    const ops = await runOperations({
                                                        key: parsed.key,
                                                        baseHash: selectedBase.projectHash,
                                                        compareHash: selectedCompare.projectHash
                                                    })

                                                    const del = await ApiService.RasCheck.RunComplete(parsed.key)

                                                    setRunning(false)

                                                    if((ops && ops.length <= 0) || !id)
                                                        return

                                                    const findResult = (_ops, key) => {
                                                        let res = {}
                                                        _ops.forEach(op => {
                                                            const x = op.children.find(x => x.key === key)
                                                            if(x) {
                                                                res = x;
                                                            }
                                                        })
                                                        return res
                                                    }

                                                    let _wsel = {}
                                                    try {
                                                        const data = {
                                                            C11: findResult(ops, 'C11') || [-1, -1], // C.11
                                                            C1: findResult(ops, 'C1') || {}, // C.1
                                                            C2: findResult(ops, 'C2') || {}, //C.2
                                                            C3: findResult(ops, 'C3') || {}, //C.3
                                                            C4: findResult(ops, 'C4') || {}, // C.4
                                                            C5: findResult(ops, 'C5') || {}, // C.5
                                                            C6: findResult(ops, 'C6') || {}, // C.6
                                                            C7: findResult(ops, 'C7') || {}, // C.7
                                                            C12: findResult(ops, 'C12') || {}, // C.12
                                                            C13: findResult(ops, 'C13') || {}, // C.13
                                                            C20: findResult(ops, 'C20') || {}, // C.12
                                                            C21: findResult(ops, 'C21') || {}, // C.13
                                                        }
                                                        _wsel = HecRasHelper.calcWSEL({
                                                            ...data,
                                                            minCS: Math.min(...selectedCompare.plan.csList.map(x => x.value)),
                                                            maxCS: Math.max(...selectedCompare.plan.csList.map(x => x.value)),
                                                            csList: selectedCompare.plan.csList
                                                        })
                                                    } catch (exp) {
                                                        console.log(exp)
                                                    }

                                                    const index = projectHistory.findIndex(x => x.id === id);
                                                    if(index < 0) {
                                                        setProjectHistory([
                                                            ...projectHistory,
                                                            {
                                                                type: 'comparison',
                                                                date: new Date(),
                                                                base: selectedBase,
                                                                compare: selectedCompare,
                                                                id,
                                                                operations: ops,
                                                                summary: {
                                                                    base: parsed.base,
                                                                    compare: parsed.compare,
                                                                },
                                                                wsel: _wsel,
                                                                filter: {
                                                                    ...filter.comparison,
                                                                    filterType: filter.filterType
                                                                }
                                                            }
                                                        ])
                                                    }
                                                    else {
                                                        let t = [...projectHistory]
                                                        t[index] = {
                                                            ...t[index],
                                                            operations: ops,
                                                            summary: {
                                                                base: parsed.base,
                                                                compare: parsed.compare,
                                                            },
                                                            wsel: _wsel,
                                                            filter: {
                                                                ...filter.comparison,
                                                                filterType: filter.filterType
                                                            }
                                                        }
                                                        setProjectHistory(t)
                                                    }
                                                }
                                            }
                                        >
                                            Compare
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'end', width: '100%', marginTop: 8}}>
                        <div style={{minWidth: 354, textAlign: 'end'}}>
                            <Typography.Text style={{marginRight: 8}}>
                                <b>Select Project Reach</b>
                            </Typography.Text>
                        </div>
                        <CrossSectionFilter csList={selectedCompare?.plan?.csList} type={'comparison'} />
                    </div>
                </Card>
                <br/>
                <OperationManager
                    type={'comparison'}
                    settings={user.settings}
                    showKey={user?.data?.email.includes('esefberfu@gmail.com') || user?.data?.email.includes('ihaltas@gmail.com')}
                    selected={selectedChild}
                    operations={operations}
                    id={getId()}
                    summaryPanel={(() => <CompareSummaryPanel preparing={preparing} />)}
                />
            </BaseLayout>
        </>
    )
}